<div class="row ms-2 me-2 mt-1 mb-1" *ngIf="vehicles.length > 0">
  <div class="col-md-3 ps-1 pe-1 d-flex align-items-center justify-content-center">
    <rb-form-select-list
      #vehicleSelector 
      [iconClass]="'rb-ic-search'" 
      [itemList]="vehicles"
      [valueIdSelector]="'deviceSerialNumber'"
      [labelIdSelector]="'name'"
      [(ngModel)]="selectedVehicles"
      [placeholder]="'Type to search a vehicle...'"
      (ngModelChange)="onVehicleSelected($event)"
      style="width: 100%;"
    ></rb-form-select-list>
  </div>
  <div class="col-md-7 ps-1 pe-1 pb-2 d-flex align-items-center">
    <div *ngFor="let vehicle of selectedVehicles; let i = index" [ngClass]="['chip-color-' + (i % 3 + 1)]" 
    class="a-chip ps-3"  style="color: white;">
      {{ vehicle?.name }}
      <span *ngIf="selectedVehicles.length === 1" style="margin-right: 10px;"></span>
      <button *ngIf="selectedVehicles.length > 1" class="close-btn rb-btn rb-passive-link" (click)="vehicleSelector.removeSelectedItem(vehicle)">
        <i class="rb-ic rb-ic-close-small" title="close"></i>
      </button>
    </div>
  </div>
  <div class="col-md-2 ps-1 pe-1 d-flex align-items-center justify-content-center">
    <rb-form-switch
      [checked]="switch.checked"
      [disabled]="switch.disabled"
      (change)="switchChange($event)">
      Compare to fleet
    </rb-form-switch>
  </div>
</div>
<div class="row ms-2 me-2 mt-1 mb-1" *ngIf="vehicles.length===0">
  <div class="col-md-12 ps-1 pe-1">
    <rb-callout type="warning">
        No vehicles found!
    </rb-callout>
  </div>
</div>

<div class="row ms-0 me-0 mt-1 mb-1">
  <rb-tab-panel class="full-width ps-0 pe-0 ms-0 me-0" *ngIf="vehicles.length > 0" (tabChanged)="onTabChange($event)">
    <div *rbTabPanelItem="'General'" class="content">
      <app-general-vehicles [compareToFleet]="compareToFleet" [selectedVehicles]="selectedVehicles" [chipSelectedVehicle]="chipSelectedVehicle" [dataLoadingError]="dataLoadingError" *ngIf="fleetId.length > 0" [fleetId]="fleetId" [companyData]="companyData" [isMetric]="isMetric"></app-general-vehicles>
    </div>
    <div *rbTabPanelItem="'Charging'" class="content">
      <app-charging-vehicles [compareToFleet]="compareToFleet" [selectedVehicles]="selectedVehicles" *ngIf="fleetId.length > 0" [fleetId]="fleetId"></app-charging-vehicles>
    </div>
    <div *rbTabPanelItem="'Duty Cycle'" class="content">
      <app-temperature-vehicles [compareToFleet]="compareToFleet" [selectedVehicles]="selectedVehicles" *ngIf="fleetId.length > 0" [fleetId]="fleetId" [companyData]="companyData" [isMetric]="isMetric"></app-temperature-vehicles>
    </div>
  </rb-tab-panel>
</div>